module.exports = require("core-js/library/fn/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/map.js
// module id = 215
// module chunks = 101